export const NAMESPACE = 'jobs-filters';

export const TOGGLE_STATUS = `${NAMESPACE}/TOGGLE_STATUS`;
export const CLEAR_STATUSES = `${NAMESPACE}/CLEAR_STATUSES`;
export const SELECT_OWNER = `${NAMESPACE}/SELECT_OWNER`;
export const CLEAR_OWNER = `${NAMESPACE}/CLEAR_OWNER`;
export const UPDATE_OWNER = `${NAMESPACE}/UPDATE_OWNER`;
